module.exports = __webpack_public_path__ + "media/images/menu/centaurus-705eeb2cd7ce53f6bb909270d2d5c6a5.jpg";